import {createListCollection, Heading, Portal, Select, Stack} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {Company, dataApi} from "../../api/data-api";
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {companyData, executorData} from "../../components/hooks/recoilData";
import {errorNotify} from "../../components/hooks/CommonUtils";
import {DocumentList} from "./documentList";

export interface DocumentExt {
    id: number | null,
    type: string,
    userId: string,
    toUserId: string,
    companyId: string,
    content: string,
    additionalInfo: string,
    sign: string,
    editable: boolean,
}

export const Document = () => {
    const [companies, setCompanies] = useState<Company[]>([]);
    const [documentDirectionType, setDocumentDirectionType] = useState<"FROM" | "TO">("TO");
    const toast = useToast();
    const [executor] = useRecoilState(executorData);
    const [company] = useRecoilState(companyData);

    useEffect(() => {
        if (company)
            setCompanies([company]);
        if (executor) {
            dataApi.companyForExecutorList(executor.ID)
                .then(o => {
                    setCompanies(prev => {
                        return [...prev, ...o]
                    });
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [toast, company, executor]);

    const documentDirectionTypes = createListCollection({
        items: [
            {label: "From", value: "FROM"},
            {label: "To", value: "TO"},
        ],
    });

    return (
        <Stack width="full" gap="5">
            <Heading size="xl">Документы</Heading>
            <Select.Root defaultValue={[documentDirectionType]} collection={documentDirectionTypes} size="sm" width="320px"
                         onChange={(e: any) => setDocumentDirectionType(e.target.value)}>
                <Select.HiddenSelect/>
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText placeholder="DirectionType"/>
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator/>
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {documentDirectionTypes.items.map((it: any) => (
                                <Select.Item item={it} key={it.value}>
                                    {it.label}
                                    <Select.ItemIndicator/>
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
            <DocumentList companies={companies} documentDirectionType={documentDirectionType} companyId={null} userId={null} editable={true}/>
        </Stack>
    );
};